import { type TranslationTree } from '@/i18n/types';

export const messages = {
  clicks: 'Cliques',
  clicksHint: {
    zero: 'Nenhum aparelho',
    one: '{{count}} aparelho diferente',
    other: '{{count}} aparelhos diferentes',
  },
  signups: 'Cadastros',
  signupsHint: 'Pessoas que se cadastraram no período',
  paying: 'Pagantes',
  payingHint: 'Desses cadastros, quantos já pagam',
} satisfies TranslationTree;
